import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminFamilyService } from '../services/admin-family.service';
import { AdminPerson } from '../interfaces/admin-person';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PersonChange } from '../interfaces/person-change';
import { ScrollToTopButtonComponent } from '../templates/scroll-to-top-button/scroll-to-top-button.component';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../services/loading.service';
import { NewFamily } from '../interfaces/new-family';

@Component({
  selector: 'app-admin-new-person',
  imports: [ScrollToTopButtonComponent, FormsModule, CommonModule],
  templateUrl: './admin-new-person.component.html',
  styleUrl: './admin-new-person.component.scss',
})
export class AdminNewPersonComponent {
  person: AdminPerson | null = null;
  error = '';
  givn = '';
  surn = '';
  nameRufname = '';
  nameNick = '';
  occu = '';
  reli = '';
  nameNpfx = '';
  nameMarnm = '';
  sour = '';
  note = '';
  birtDate = '';
  birtPlac = '';
  deatDate = '';
  deatPlac = '';
  chrDate = '';
  chrPlac = '';
  chrAddr = '';
  buriDate = '';
  buriPlac = '';
  sex = 'D';
  confidential = 'restricted';
  imageFiles: (File | null)[] = [
    null,
    null,
    null,
    null,
    null,
    null
  ];
  imagePreviews: (string | null)[] = [
    null,
    null,
    null,
    null,
    null,
    null
  ];
  deletedImageSlots = new Set<number>();;
  pendingChanges: PersonChange[] = [];
  noNewChanges: boolean = true;
  showSaveConfirmation = false;
  expandedMarriageBoxes = new Set<number>();
  personPopupOpen = false;
  personPopupType: 'father' | 'mother' | 'spouse' | 'child' | null = null;
  personPopupMarriageIndex: number | null = null;
  personPopupChildIndex: number | null = null;
  personPopupPerson: AdminPerson | null = null;
  personSearchTerm = '';
  personSearchResults: AdminPerson[] = [];
  personSearchLoading = false;
  personPopupSelectedPerson: AdminPerson | null = null;

  family: NewFamily = {
    parents: [null, null],

    marriages: [
      {
        spouse: null,
        marr_date: null,
        marr_plac: null,
        fam_stat: null,
        children: []
      },
      {
        spouse: null,
        marr_date: null,
        marr_plac: null,
        fam_stat: null,
        children: []
      },
      {
        spouse: null,
        marr_date: null,
        marr_plac: null,
        fam_stat: null,
        children: []
      },
      {
        spouse: null,
        marr_date: null,
        marr_plac: null,
        fam_stat: null,
        children: []
      }
    ]
  };

  familyStatusChoices = [
    { value: 'married', label: 'verheiratet' },
    { value: 'not_married', label: 'nicht verheiratet' },
    { value: 'widowed', label: 'verwitwet' },
    { value: 'divorced', label: 'geschieden' }
  ];
  availableFamilies: string[] = [];
  selectedFamily = '';
  successMessage = '';
  showSuccessPopup = false;
  createdPersonRefn: string | null = null;
  existingPersons: AdminPerson[] = [];
  showExistingPersonPopup = false;
  checkingExistingPersons = false;


  constructor(
    private route: ActivatedRoute, private router: Router,
    private adminFamilyService: AdminFamilyService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    const family1 = localStorage.getItem('family_1');
    const family2 = localStorage.getItem('family_2');

    this.availableFamilies = [family1, family2]
      .filter(
        (family): family is string =>
          !!family && family !== 'null'
      );

    if (this.availableFamilies.length === 1) {
      this.selectedFamily = this.availableFamilies[0];
    }
  }

  save(): void {
    this.error ='';
    if (!this.selectedFamily) {
      alert('Bitte wähle einen Stammbaum aus.');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    const dateError = this.adminFamilyService.validateBirthDeathDates(
      this.birtDate,
      this.deatDate
    );
    if (dateError) {
      this.error = dateError;
      alert(dateError);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    this.checkExistingPerson();
  }

  private checkExistingPerson(): void {
    const givn = this.givn.trim() || '';
    const surn = this.surn.trim() || '';
    const search = `${givn} ${surn}`.trim();

    if (!search) {
      this.continueSave();
      return;
    }

    this.adminFamilyService.searchPersons(search).subscribe({
      next: persons => {
        const normalize = (value: string | null | undefined) =>
          (value ?? '').trim().toLocaleLowerCase();

        this.existingPersons = persons.filter(person =>
          normalize(person.givn) === normalize(this.givn) &&
          normalize(person.surn) === normalize(this.surn)
        );

        if (this.existingPersons.length > 0) {
          this.showExistingPersonPopup = true;
          return;
        }

        this.continueSave();
      },
      error: error => {
        this.checkingExistingPersons = false;
        console.error('Fehler bei der Prüfung auf bestehende Personen:', error);
        alert('Die Namensprüfung ist fehlgeschlagen. Bitte versuche es erneut.');
      }
    });
  }

  openExistingPerson(person: AdminPerson): void {
    this.showExistingPersonPopup = false;

    this.router.navigate([
      '/admin-ancestors/person',
      person.refn
    ]);
  }

  createAnyway(): void {
    this.showExistingPersonPopup = false;
    this.continueSave();
  }

  cancelExistingPersonCheck(): void {
    this.showExistingPersonPopup = false;
  }

  private continueSave(): void {
    this.pendingChanges = this.getChanges();
    this.noNewChanges = this.pendingChanges.length === 0;
    this.showSaveConfirmation = true;
  }


  confirmSave(): void {

    this.showSaveConfirmation = false;
    this.error = '';

    const personData = this.assemblePersonData();

    this.adminFamilyService
      .createPerson(personData)
      .subscribe({
        next: response => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          this.clearPersonData();
          this.clearRelationData();
          this.successMessage = ' Person wurde erfolgreich angelegt.';
          this.createdPersonRefn = response.person.refn;
          this.showSuccessPopup = true;
        },
        error: error => {
          console.error(error);
          this.loadingService.hide();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          this.error =
            `Person konnte nicht gespeichert werden. (${error.status})`;
          alert(this.error);
        },
        complete: () => {
          this.loadingService.hide();
        }
      });
  }

  private assemblePersonData(): FormData {
    const formData = new FormData();

    formData.append('givn', this.givn);
    formData.append('surn', this.surn);
    formData.append('name_rufname', this.nameRufname);
    formData.append('name_nick', this.nameNick);
    formData.append('occu', this.occu);
    formData.append('reli', this.reli);
    formData.append('name_npfx', this.nameNpfx);
    formData.append('name_marnm', this.nameMarnm);
    formData.append('sour', this.sour);
    formData.append('note', this.note);
    formData.append('birt_date', this.birtDate);
    formData.append('birt_plac', this.birtPlac);
    formData.append('deat_date', this.deatDate);
    formData.append('deat_plac', this.deatPlac);
    formData.append('chr_date', this.chrDate);
    formData.append('chr_plac', this.chrPlac);
    formData.append('chr_addr', this.chrAddr);
    formData.append('buri_date', this.buriDate);
    formData.append('buri_plac', this.buriPlac);
    formData.append('sex', this.sex);
    formData.append('confidential', this.confidential);
    formData.append('family_1', this.selectedFamily);

    this.appendImageData(formData);
    return formData;
  }

  private appendImageData(formData: FormData): void {

    for (let i = 0; i < 6; i++) {
      const file = this.imageFiles[i];

      if (file) {
        formData.append(
          `obje_file_${i + 1}`,
          file,
          file.name
        );
      }
    }
  }

  cancel(): void {
    this.router.navigate(['/admin-ancestors']);
  }

  cancelSave(): void {
    this.showSaveConfirmation = false;
  }

  getChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    const addChange = (
      label: string,
      value: string | null | undefined,
      defaultValue: string = ''
    ): void => {
      const newValue = value?.trim() ?? '';

      if (newValue && newValue !== defaultValue) {
        changes.push({
          label,
          oldValue: '',
          newValue
        });
      }
    };

    addChange('Vorname', this.givn);
    addChange('Nachname', this.surn);
    addChange('Rufname', this.nameRufname);
    addChange('Spitzname', this.nameNick);
    addChange('Beruf', this.occu);
    addChange('Religion', this.reli);
    addChange('Namenspräfix', this.nameNpfx);
    addChange('Geburtsname', this.nameMarnm);
    addChange('Quelle', this.sour);
    addChange('Notiz', this.note);
    addChange('Geburtsdatum', this.birtDate);
    addChange('Geburtsort', this.birtPlac);
    addChange('Sterbedatum', this.deatDate);
    addChange('Sterbeort', this.deatPlac);
    addChange('Taufdatum', this.chrDate);
    addChange('Taufort', this.chrPlac);
    addChange('Beerdigungsdatum', this.buriDate);
    addChange('Beerdigungsort', this.buriPlac);
    addChange('Tauf-/Kirchenadresse', this.chrAddr);
    addChange('Geschlecht', this.getSexLabel(this.sex), this.getSexLabel('D'));
    addChange('Vertraulichkeit', this.getConfidentialLabel(this.confidential), this.getConfidentialLabel('restricted'));

    changes.push(...this.getFamilyChanges());
    changes.push(...this.getParentChanges());
    changes.push(...this.getSpousesChanges());
    changes.push(...this.getMarriageDataChanges());
    changes.push(...this.getChildrenChanges());

    changes.push(...this.getPictureChanges());

    return changes;
  }


  private getSexLabel(value: string | null | undefined): string {
    switch (value) {
      case 'M':
        return 'Männlich';
      case 'F':
        return 'Weiblich';
      case 'D':
        return 'Divers';
      default:
        return '';
    }
  }

  private getConfidentialLabel(value: string | null | undefined): string {
    switch (value) {
      case 'restricted':
        return 'Vertraulich';
      case 'no':
        return 'Nicht vertraulich';
      default:
        return '';
    }
  }

  private getFamilyChanges(): PersonChange[] {
    if (!this.selectedFamily) {
      return [];
    }

    const familyLabel =
      this.selectedFamily === 'kempe'
        ? 'Kempe'
        : this.selectedFamily === 'huenten'
          ? 'Hünten'
          : this.selectedFamily;

    return [
      {
        label: 'Stammbaum',
        oldValue: '',
        newValue: familyLabel
      }
    ];
  }

  private getParentChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    const father = this.family.parents[0];

    if (father) {
      changes.push({
        label: 'Vater',
        oldValue: '',
        newValue: father.name
      });
    }

    const mother = this.family.parents[1];

    if (mother) {
      changes.push({
        label: 'Mutter',
        oldValue: '',
        newValue: mother.name
      });
    }

    return changes;
  }

  private getSpousesChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    this.family.marriages.forEach((marriage, i) => {
      if (marriage.spouse) {
        changes.push({
          label: `Partnerschaft ${i + 1}`,
          oldValue: '',
          newValue: marriage.spouse.name
        });
      }
    });

    return changes;
  }

  private getMarriageDataChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    for (let i = 0; i < this.family.marriages.length; i++) {
      const marriage = this.family.marriages[i];
      const index = i + 1;

      if (marriage.marr_date?.trim()) {
        changes.push({
          label: `Heiratsdatum ${index}`,
          oldValue: '',
          newValue: marriage.marr_date
        });
      }

      if (marriage.marr_plac?.trim()) {
        changes.push({
          label: `Heiratsort ${index}`,
          oldValue: '',
          newValue: marriage.marr_plac
        });
      }

      if (marriage.fam_stat) {
        const status = this.familyStatusChoices.find(
          choice => choice.value === marriage.fam_stat
        );

        changes.push({
          label: `Familienstand ${index}`,
          oldValue: '',
          newValue: status?.label ?? marriage.fam_stat
        });
      }
    }

    return changes;
  }

  private getChildrenChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    for (let i = 0; i < this.family.marriages.length; i++) {
      const marriage = this.family.marriages[i];
      const index = i + 1;

      const childrenText = marriage.children
        .filter((child): child is AdminPerson => child !== null)
        .map(child => child.name)
        .join(', ');

      if (childrenText) {
        changes.push({
          label: `Kinder aus Partnerschaft ${index}`,
          oldValue: '',
          newValue: childrenText
        });
      }
    }

    return changes;
  }

  private getPictureChanges(): PersonChange[] {
    const changes: PersonChange[] = [];

    for (let i = 1; i <= 6; i++) {
      const newFile = this.imageFiles[i - 1];

      if (newFile) {
        changes.push({
          label: `Bild ${i}`,
          oldValue: '',
          newValue: `hinzugefügt: ${newFile.name}`
        });
      }
    }

    return changes;
  }

  clearPersonData(): void {

    this.givn = '';
    this.surn = '';
    this.nameRufname = '';
    this.nameNick = '';
    this.occu = '';
    this.reli = '';
    this.nameNpfx = '';
    this.nameMarnm = '';
    this.sour = '';
    this.note = '';

    this.birtDate = '';
    this.birtPlac = '';

    this.deatDate = '';
    this.deatPlac = '';

    this.chrDate = '';
    this.chrPlac = '';
    this.chrAddr = '';

    this.buriDate = '';
    this.buriPlac = '';

    this.sex = 'D';
    this.confidential = 'no';

    this.imageFiles = [
      null, null, null, null, null, null
    ];

    this.deletedImageSlots.clear();

    this.imagePreviews = [
      null, null, null, null, null, null
    ];
  }

  clearRelationData(): void {
    this.family = {
      parents: [null, null],
      marriages: [
        {
          spouse: null,
          marr_date: null,
          marr_plac: null,
          fam_stat: null,
          children: []
        },
        {
          spouse: null,
          marr_date: null,
          marr_plac: null,
          fam_stat: null,
          children: []
        },
        {
          spouse: null,
          marr_date: null,
          marr_plac: null,
          fam_stat: null,
          children: []
        },
        {
          spouse: null,
          marr_date: null,
          marr_plac: null,
          fam_stat: null,
          children: []
        }
      ]
    };

    this.expandedMarriageBoxes.clear();
  }

  onImageFileChange(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    if (
      file.type !== 'image/jpeg' &&
      file.type !== 'image/png'
    ) {
      alert('Nur JPG und PNG Dateien sind erlaubt.');
      input.value = '';
      return;
    }

    this.imageFiles[index - 1] = file;
    this.imagePreviews[index - 1] =
      URL.createObjectURL(file);
  }

  removeImagePreview(index: number): void {
    this.imagePreviews[index - 1] = null;
    this.imageFiles[index - 1] = null;
    const input = document.getElementById(
      `image${index}`
    ) as HTMLInputElement | null;

    if (input) {
      input.value = '';
    }
  }

  openPersonPopup(
    type: 'spouse' | 'child' | 'father' | 'mother',
    marriageIndex: number,
    person: AdminPerson | null,
    childIndex: number | null = null
  ): void {
    this.personPopupType = type;
    this.personPopupMarriageIndex = marriageIndex;
    this.personPopupChildIndex = childIndex;
    this.personPopupPerson = person;
    this.personPopupSelectedPerson = person;
    this.personSearchTerm = '';
    this.personSearchResults = [];
    this.personPopupOpen = true;
  }

  closePersonPopup(): void {
    this.personPopupOpen = false;
    this.personPopupType = null;
    this.personPopupMarriageIndex = null;
    this.personPopupChildIndex = null;
    this.personPopupPerson = null;
    this.personPopupSelectedPerson = null;
    this.personSearchTerm = '';
    this.personSearchResults = [];
  }

  searchPersons() {
    const search = this.personSearchTerm.trim();
    if (!search) {
      this.personSearchResults = [];
      return;
    }
    this.personSearchLoading = true;
    this.adminFamilyService.searchRelatedPersons(search).subscribe({
      next: (persons) => {
        this.personSearchResults = persons;
        this.personSearchLoading = false;
      },
      error: (error) => {
        console.error('Fehler bei der Personensuche:', error);
        this.personSearchResults = [];
        this.personSearchLoading = false;
      }
    });
  }

  selectPerson(person: AdminPerson): void {
    this.personPopupSelectedPerson = person;
  }

  savePersonPopup(): void {
    if (!this.personPopupSelectedPerson) {
      return;
    }

    const person = this.personPopupSelectedPerson;

    switch (this.personPopupType) {

      case 'father':
        if (this.family) {
          this.family.parents[0] = person;
        }
        break;

      case 'mother':
        if (this.family) {
          this.family.parents[1] = person;
        }
        break;

      case 'spouse':
        if (
          this.family &&
          this.personPopupMarriageIndex !== null
        ) {
          this.family.marriages[
            this.personPopupMarriageIndex
          ].spouse = person;
        }
        break;

      case 'child':
        if (
          this.family &&
          this.personPopupMarriageIndex !== null
        ) {
          const marriage =
            this.family.marriages[
            this.personPopupMarriageIndex
            ];

          if (this.personPopupChildIndex !== null) {
            marriage.children[
              this.personPopupChildIndex
            ] = person;
          } else {
            marriage.children.push(person);
          }
        }
        break;
    }

    this.closePersonPopup();
  }

  removePersonFromPopup(): void {

    switch (this.personPopupType) {

      case 'father':
        this.family.parents[0] = null;
        break;

      case 'mother':
        this.family.parents[1] = null;
        break;

      case 'spouse':
        if (this.personPopupMarriageIndex !== null) {
          this.family.marriages[
            this.personPopupMarriageIndex
          ].spouse = null;
        }
        break;

      case 'child':
        if (
          this.personPopupMarriageIndex !== null &&
          this.personPopupChildIndex !== null
        ) {
          this.family.marriages[
            this.personPopupMarriageIndex
          ].children.splice(
            this.personPopupChildIndex,
            1
          );
        }
        break;
    }

    this.closePersonPopup();
  }

  newPartnerChildBox(index: number): void {
    this.expandedMarriageBoxes.add(index);
  }


  getFamilyLabel(family: string): string {
    switch (family) {
      case 'kempe':
        return 'Kempe';
      case 'huenten':
        return 'Hünten';
      default:
        return family;
    }
  }

  goToSearch(): void {
    this.pendingChanges = this.getChanges();
      if (this.availableFamilies.length === 1) {
    this.pendingChanges = this.pendingChanges.filter(
      change => change.label !== 'Stammbaum'
    );
  }
    if (this.pendingChanges.length > 0) {
      const proceed = window.confirm(
        'Es gibt ungespeicherte Änderungen.\n\n' +
        'Bitte speichere die Änderungen zuerst, bevor du eine neue Person anlegst.\n\n' +
        'Möchtest du trotzdem zur Suche wechseln?'
      );

      if (!proceed) {
        return;
      }
    }

    this.router.navigate(['/admin-ancestors']);
  }

  goToCreatedPerson(): void {
    if (!this.createdPersonRefn) {
      return;
    }

    this.showSuccessPopup = false;

    this.router.navigate([
      '/admin-ancestors/person',
      this.createdPersonRefn
    ]);
  }

  goToNewPerson(): void {
    this.showSuccessPopup = false;

    this.router.navigate([
      '/admin-ancestors/newperson'
    ]);
  }
}
